import { render, staticRenderFns } from "./ProjectsQuotes.vue?vue&type=template&id=6531bd3f&scoped=true"
import script from "./ProjectsQuotes.vue?vue&type=script&lang=js"
export * from "./ProjectsQuotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6531bd3f",
  null
  
)

export default component.exports